import React, { useState } from "react";
import { PresentView } from "../Views/presentView";
import { NextPrevParts } from "../Parts/nextPrevParts";
import { FlowParts } from "../Parts/flowParts";

import { useForm } from "react-hook-form";
import Data from "src/data/presents.json"

export const PresentPage = (props) => {

    window.scrollTo(0,0)
    

    const defaultPresent = props.defaultValue.present 
                        ? props.defaultValue.present : {
                                'color':'',
                                'name' :'',
                                'id':''
                            }
       
    const {setValue, handleSubmit, register, watch} = useForm({
		defaultValues: defaultPresent
	})


    const onSelectPresent = (currentInput) => {
        const presentData = Data.data.filter((present, index) => { 
            return present.id === currentInput.id;
        })[0]

        if(presentData === undefined){
            alert('賞品を選択してください。')
        }else if(presentData.colorSelect && !currentInput.color){
            alert('カラーを選択してください。')
        }else{
            const selectPresent = presentData.colorSelect ? 
                                        {
                                            ...presentData,
                                            color:currentInput.color
                                        } : presentData
            
            props.setPresent(selectPresent)
            props.next()
        }
      
    }

    return (
        
        <div className="select_present">
        <FlowParts {...{flow:'flow1'}}></FlowParts>
        <div className="block5 mb-30">
			<div className="block5_1"><img src={`${process.env.REACT_APP_HOME_URL}/images/prize_desc.png`} alt=""/></div>
			<div className="block5_2"><a className="btn6" onClick={props.prev}>戻る</a></div>
		</div>
        <div className="prize_content">
            <div className="single_select">
                <form onSubmit={handleSubmit(onSelectPresent)}>
                    <PresentView {...{
                        setValue, 
                        register, 
                        watch,
                        defaultPresent}}></PresentView>
                    <p className="prize_note">
                    <span>※本キャンペーンは一般社団法人福岡県LPガス協会による提供です。 本キャンペーンについてのお問い合わせは Amazon ではお受けしておりません。 </span><br/>
                    <span>一般社団法人福岡県LPガス協会キャンペーン事務局【TEL.092-476-3838】までお願いいたします。</span><span>※ Amazon、Amazon.co.jp およびそれらのロゴは Amazon.com, Inc.またはその関連会社の商標です。</span>
                    </p>
                    <div className="block3 fiexed">
                        <div className="block3_1">
                        <button  type="submit" className="btn8">賞品決定</button></div>
                        <div className="block3_2" 
                        onClick={props.prev}><a className="btn6">戻る</a></div>
                    </div>
                </form>
            </div>
        </div>
        </div>
    )
    
}